function initializeMap(mapInstance) {
    let mapOptions = {
        zoom: parseInt(mapInstance.zoom),
        center: mapInstance.center,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    let map = new google.maps.Map(mapInstance.mapElement, mapOptions);

    let bounds = new google.maps.LatLngBounds();

    mapInstance.points.forEach(function(point){

        let info = new google.maps.InfoWindow({
            content: point.message,
        });

        let marker = new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(point.lat, point.lng),
            title: point.title,
        });

        bounds.extend(marker.getPosition());

        google.maps.event.addListener(marker, 'click', function() {
            info.open(map, marker);
        });
    });

    if(mapInstance.center === null) {
        map.fitBounds(bounds);

        let listener = google.maps.event.addListener(map, "idle", function() {
          if (map.getZoom() > mapOptions.zoom) map.setZoom(mapOptions.zoom);
          google.maps.event.removeListener(listener);
        });
    }
}

function addMapScripts(key, callback) {
    if(key) {
        let googleMapsUrl = `https://maps.googleapis.com/maps/api/js?key=${key}`;

        if (!document.querySelectorAll(`[src="${googleMapsUrl}"]`).length) {
            document.body.appendChild(Object.assign(
                document.createElement('script'), {
                    type: 'text/javascript',
                    src: googleMapsUrl,
                    onload: () => callback()
                })
            );
        }
    }
}

export function initialize() {
    let maps = document.querySelectorAll('[data-map="dynamic"]');

    let initialize = function() {
        maps.forEach(function(mapBlock) {
            initializeMap(new Map(mapBlock));
        });
    };

    maps.forEach(function(mapBlock) {
        addMapScripts(mapBlock.getAttribute('data-key'), initialize);
    });
}

export class MapPoint {
    constructor(lat, lng, message, title) {
        this.lat = lat;
        this.lng = lng;
        this.message = message;
        this.title = title;
    }
}

export class Map {
    constructor(element) {
        this.mapElement = element;
        this.zoom = element.getAttribute('data-zoom');
        this.points = this.readPoints(this.mapElement);
        this.center = this.readCenter(this.mapElement);
    }

    readPoints(mapElement) {
        let points = [];

        mapElement.querySelectorAll('[data-map="point"]').forEach(function(point) {
            points.push(new MapPoint(
                point.getAttribute('data-lat'),
                point.getAttribute('data-lng'),
                point.innerHTML,
                point.getAttribute('title'),
            ));
        });

        return points;
    }

    readCenter(mapElement) {
        let centerElement = mapElement.querySelector('[data-map="center"]');

        if(centerElement) {
            return new google.maps.LatLng(
                parseFloat(centerElement.getAttribute('data-lat')),
                parseFloat(centerElement.getAttribute('data-lng'))
            );
        }

        return null;
    }
}
